<form [formGroup]="gstreportFilterForm" class="ledger-filter-form">
    <div class="flexbox aff-info">
      <div class="flexbox aff-info-inner" style="width: 100%;">
        <div class="flexbox "></div>
        <div class="flexbox mb-3">
            <div class="text-input-fiel bank-acc">
                <!-- <input class="input-ui" formControlName="start_date" id="from_date" type="date"
                    [ngClass]="{'error-box': !gstreportFilterForm.controls.start_date.valid}"
                    searchtabindex="1"   /> -->
                <ng-container *ngIf="isLocaleDateFormat">
                        <input class="input-ui" searchtabindex="1" formControlName="start_date" id="date" type="date"
                        [ngClass]="{'error-box': !gstreportFilterForm.controls.start_date.valid}"
                         />
                </ng-container>
                <ng-container *ngIf="!isLocaleDateFormat && gstreportFilterForm.controls.start_date">
                        <app-date-time-input
                        formControlName="start_date"
                        [dateFormat]="dateFormat"
                        [fieldController]="gstreportFilterForm.controls.start_date"
                        class="new-date-input"
                        classes="inv-date-input" 
                        tIndex="1"
                        ></app-date-time-input>
                </ng-container>               
                <label for="from_date">Starting Date</label>
            </div>
            <div class="text-input-fiel bank-acc">
                <!-- <input class="input-ui" formControlName="end_date" id="to_date" type="date" searchtabindex="2" 
                [ngClass]="{'error-box': !gstreportFilterForm.controls.end_date.valid}"
                      /> -->

                <ng-container *ngIf="isLocaleDateFormat">
                        <input class="input-ui" searchtabindex="2" formControlName="end_date" id="date" type="date"
                        [ngClass]="{'error-box': !gstreportFilterForm.controls.end_date.valid}"
                         />
                </ng-container>
                <ng-container *ngIf="!isLocaleDateFormat && gstreportFilterForm.controls.end_date">
                        <app-date-time-input
                        formControlName="end_date"
                        [dateFormat]="dateFormat"
                        [fieldController]="gstreportFilterForm.controls.end_date"
                        class="new-date-input"
                        classes="inv-date-input" 
                        tIndex="2"
                        ></app-date-time-input>
                </ng-container>               
                <label for="to_date">Ending Date</label>
            </div>
        </div>
        <div class="d-flex mt-5 justify-content-center">
        <div class="input-fiel">
          <button id="submitSearchForm" type="button" class="btn-style bg-purple mr-3" data-dismiss="modal"
            searchtabindex="3" #searchButton (keyup.enter)="clickSearchButton()"
            [disabled]="gstreportFilterForm.invalid"
            (click)="search(gstreportFilterForm.value)">
            Search</button>
          <button type="button" class="btn-style bg-green" id="resetSearchForm" (click)="reset()">RESET</button>
        </div>
      </div>
      </div>
    </div>
  </form>